import { render } from "./paginationWidget.vue?vue&type=template&id=6970ab5a&scoped=true"
import script from "./paginationWidget.vue?vue&type=script&lang=js"
export * from "./paginationWidget.vue?vue&type=script&lang=js"

import "./paginationWidget.vue?vue&type=style&index=0&id=6970ab5a&scoped=true&lang=css"

import exportComponent from "/Users/song/Desktop/pro/homePage/沙漠传说/desertlegendhomepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6970ab5a"]])

export default __exports__